module.exports = __webpack_public_path__ + "img/education.51208382.jpg";